module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAX0lEQVRYhe3WwQnAIAxA0di5OpPDdKbuZWmh5w8aJIf/QPCWj14S2mH0c7wnY9RR7ccMIgYRg4hBxCBiECkX1P5L1vowHXLdX0u5F0rhgraTQcQgYhAxiBhEDNKSiHgAI+wO3MdzAvIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/@2x/ic_btn_plus@2x.png
// module id = 306
// module chunks = 0